import {ObjectComboMapping} from "../../../model/object-combo-mapping";
import {otsBaseApi} from "../../ots-api";
import {EntityIdentifier} from "../../../model/entity";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['ObjectComboMappings']})

const objectComboMappingApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getObjectComboMappingsByObject: builder.query<ObjectComboMapping[], EntityIdentifier>(
      {
        query: (eo) => ({
          url: '/object-combo-mappings/object',
          method: 'GET',
          params: {objectId: eo.id, objectType: eo.type},
        }),
        providesTags: (result) => {
          if (result) {
            return [
              ...result.map(
                ({id}) => ({type: 'ObjectComboMappings', id} as const)
              ),
              {type: 'ObjectComboMappings', id: 'LIST'},
            ];
          } else {
            return [{type: 'ObjectComboMappings', id: 'LIST'}];
          }
        },
      }
    ),
    getObjectComboMapping: builder.query<ObjectComboMapping, string>({
      query: (id) => ({
        url: `/object-combo-mappings/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{type: 'ObjectComboMappings', id}],
    }),
    createObjectComboMapping: builder.mutation<void, Partial<ObjectComboMapping>>({
      query: (mapping) => ({
        url: '/object-combo-mappings',
        method: 'POST',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: [{type: 'ObjectComboMappings', id: 'LIST'}],
    }),
    updateObjectComboMapping: builder.mutation<void, Partial<ObjectComboMapping>>({
      query: (mapping) => ({
        url: '/object-combo-mappings',
        method: 'PUT',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: 'ObjectComboMappings', id},
      ],
    }),
    deleteObjectComboMapping: builder.mutation<void, Partial<ObjectComboMapping>>({
      query: (mapping) => ({
        url: `/object-combo-mappings/${mapping.id}`,
        method: 'DELETE',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: 'ObjectComboMappings', id},
      ],
    }),
  }),
})

export const {
  useGetObjectComboMappingsByObjectQuery,
  useGetObjectComboMappingQuery,
  useCreateObjectComboMappingMutation,
  useUpdateObjectComboMappingMutation,
  useDeleteObjectComboMappingMutation,
} = objectComboMappingApi;
